import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button, Tabs, Tab } from "react-bootstrap";
import AuthLogoCard from "../../components/common/authLogoCard";
import { MESSAGE } from '../../utils/message';
import AlreadyHaveAccount from "../../components/common/alreadyAccount";
import SignUPForm from "./userSignUpForm";
import Left_arrow_icon from "../../assests/images/arrow-down.svg";
import Great_Non_Profits_Img from "../../assests/images/ls-page-image/great-nonprofits-img.svg";
import {
    SignUpSection,
    SignUpLeftPart,
    SignUpRightPart,
    BackToHomeBtn,
    GreatNonProfitsImg,
    UserCreateTitle,
    FormTitle,
    TabViewForm,
    PrivacyText,
} from "./signUpStyle";
import { useNavigate } from "react-router-dom";
import MetaComponent from "../../components/common/metaComponent";
import { openInNewTab } from "../../utils/functions";

const SignUp = () => {
    const navigate: any = useNavigate();
    const [userType, setUserType] = useState("individual");
    const handleSelect = (key: any) => {
        setUserType(key);
    };

    return (
        <>
            <MetaComponent
                keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
                description="Sign up with GreatNonprofits to share reviews, discover top-rated nonprofits, and make an impact in your community. Join as an individual or nonprofit today!"
                ogTitle="Sign Up | Join GreatNonprofits to Support Nonprofits"
                ogDescription="Sign up with GreatNonprofits to share reviews, discover top-rated nonprofits, and make an impact in your community. Join as an individual or nonprofit today!"
                ogUrl="https://new.greatnonprofits.org/signup"
                ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                twitterTitle="Sign Up | Join GreatNonprofits to Support Nonprofits"
                twitterDescription="Sign up with GreatNonprofits to share reviews, discover top-rated nonprofits, and make an impact in your community. Join as an individual or nonprofit today!"
                twitterUrl="https://new.greatnonprofits.org/signup"
                twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                canonicalUrl="https://new.greatnonprofits.org/signup"
            />
            <SignUpSection>
                <Container fluid>
                    <Row className="signUp-col">
                        <SignUpLeftPart as={Col} sm={12} md={6} lg={6}>
                            <AuthLogoCard userType={userType} />
                        </SignUpLeftPart>
                        <SignUpRightPart as={Col} sm={12} md={6} lg={6}>
                            <BackToHomeBtn>
                                <Button onClick={() => navigate("/")} className="back-btn"><Image src={Left_arrow_icon} alt="Back Arrow" width="5px" height="12px" />{MESSAGE.backToWebsite}</Button>
                            </BackToHomeBtn>
                            <GreatNonProfitsImg onClick={() => navigate("/")}>
                                <Image src={Great_Non_Profits_Img} alt="Brand Logo" width="324px" height="24px" />
                            </GreatNonProfitsImg>
                            <UserCreateTitle>
                                <FormTitle>{MESSAGE.joinOurCommunity}</FormTitle>
                            </UserCreateTitle>
                            <TabViewForm>
                                <Tabs defaultActiveKey="individual" onSelect={(eventKey: any) => handleSelect(eventKey)}>
                                    <Tab eventKey="individual" title="I'm an Individual">
                                    </Tab>

                                    <Tab eventKey="nonprofit" title="I'm a Nonprofit">
                                    </Tab>
                                </Tabs>
                                <SignUPForm userType={userType} />
                            </TabViewForm>
                            <AlreadyHaveAccount />
                            <PrivacyText>By creating an account, you agree to GreatNonprofits <Button onClick={() => openInNewTab("https://new.greatnonprofits.org/pages/terms-of-service/")}>{MESSAGE.termsOfService}</Button> and <Button onClick={() => openInNewTab("https://new.greatnonprofits.org/pages/privacy-policy/")}>{MESSAGE.privacyPolicy}</Button></PrivacyText>
                        </SignUpRightPart>
                    </Row>
                </Container>
            </SignUpSection>
        </>

    )
};
export default SignUp;
